import { Reveal } from "./motion";
import { TRUST } from "../lib/site";

const StatBand = () => (
  <section className="container-ek py-20 lg:py-24">
    <Reveal>
      <div className="grid grid-cols-1 border border-white/10 bg-navy2/60 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST.map((t, i) => (
          <div
            key={i}
            data-testid={`trust-stat-${i}`}
            className={`group px-8 py-10 transition-colors duration-500 hover:bg-navy3/70 ${
              i > 0 ? "border-t border-white/10 sm:border-t-0" : ""
            } ${i % 2 === 1 ? "sm:border-l" : ""} ${i > 1 ? "lg:border-l" : ""} ${
              i === 2 ? "sm:border-t lg:border-t-0" : ""
            } ${i === 3 ? "sm:border-t lg:border-t-0" : ""}`}
          >
            <p className="font-serif text-4xl font-medium text-gold md:text-5xl">{t.value}</p>
            <p className="mt-3 text-[13px] font-semibold uppercase tracking-[0.18em] text-white">
              {t.label}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-mist">{t.desc}</p>
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);

export default StatBand;
